import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import {
    getSubscriptionTypeSagaAction,
    removeSubscriptionTypeSagaAction,
    sortSagaAction
} from "../../redux/sagaActions";

const SubscriptionTypes = () => {
    const dispatch = useDispatch();
    const subscription_types = useSelector(state => state.subscription_types);

    const [list, setList] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...subscription_types];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'types',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    return (
        <div className="settings">
            <ReactSortable
                list={ list }
                setList={ setList }
                handle={ '.control--move' }
                onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
            >
                {
                    subscription_types.map(elem => {
                        return (
                            <div className="setting" key={ elem.id }>
                                <div className="controls">
                                    <i className="control control--edit" onClick={ () => {
                                        dispatch(getSubscriptionTypeSagaAction({ id: elem.id }));
                                    } } />
                                    <i className="control control--move" />
                                    <i className="control control--remove" onClick={ () => {
                                        if (window.confirm('Вы действительно хотите удалить этот тип абонемента?')) {
                                            dispatch(removeSubscriptionTypeSagaAction({ id: elem.id }));
                                        }
                                    } } />
                                </div>
                                <div className="setting__caption">{ elem.name }</div>
                            </div>
                        )
                    })
                }
            </ReactSortable>
        </div>
    );
};

export default SubscriptionTypes;